export const turquoise: string = "rgba(6, 180, 200, 1)";
export const lightTurquoise: string = "rgba(6, 180, 200, 0.29)";
export const darkGreen: string = "rgba(1, 57, 63, 1)";
export const lightGreen: string = "rgba(66, 219, 137, 1)";
export const lightGrey: string = "rgba(113, 112, 112, 1)";
export const veryLightGrey: string = "#C4C4C4";
export const pink: string = "rgba(255, 131, 131, 1)";
export const orange: string = "rgba(248, 158, 106, 1)";
export const darkGrey: string = "rgba(32, 32, 32, 1)";
